// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"3f4a8588","882":"31f23358"}[chunkId] + ".chunk.js";
};